import { render, staticRenderFns } from "./ele3.vue?vue&type=template&id=d64fe8ea&scoped=true"
import script from "./ele3.vue?vue&type=script&lang=js"
export * from "./ele3.vue?vue&type=script&lang=js"
import style0 from "./ele3.vue?vue&type=style&index=0&id=d64fe8ea&prod&lang=scss"
import style1 from "./ele3.vue?vue&type=style&index=1&id=d64fe8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64fe8ea",
  null
  
)

export default component.exports